const DateAdded = ({ date_added }: { date_added: string }) => {
  return <div className="capitalize"> {date_added} </div>;
};

export default DateAdded;
